<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
    <div id="article-view">
        <div  v-if="infos" id="main-content" class="container-size-fixer row">
            <div v-if="loadingMood==false" :class="infos.related_posts ? 'col-lg-9 col-md-8 col-sm-12 article-content' : 'col-sm-12 article-content'">
                <div class="article-header">
                    <div id="direction">
                        <ul>
                            <li>خانه</li>
                            <li><img class="arrow" width="7" height="7" src="../assets/new/New/Icon/LeftBreadcrumb.png"
                                     alt=""></li>
                            <li v-if="infos.postDetails.main_category" v-on:click="$router.push('/category-view/'+infos.postDetails.main_category.slug)">
                               {{infos.postDetails.main_category.name}}
                            </li>
                            <li><img class="arrow" width="7" height="7" src="../assets/new/New/Icon/LeftBreadcrumb.png"
                                     alt=""></li>
                            <li>
                                {{infos.postDetails.title}}
                            </li>
                        </ul>
                    </div>
                    <div class="title">
                        {{infos.postDetails.title}}
                    </div>
                    <ul class="article-header-details">
                        <li>
                                <img width="17" height="20" src="../assets/new/New/Icon/Comments.png" alt="">
                                {{infos.commentsCount}} نظر
                        </li>
                        <li>
                                <img width="20" height="15" src="../assets/new/New/Icon/EyeView.png" alt="">
                            {{infos.visitorsCount}} بازدید
                        </li>

                        <li style="position: relative" @mouseover="showDetails('dateMoreDetails')" @mouseleave="hideDetails('dateMoreDetails')">
                                <img width="15" height="20" src="../assets/new/New/Icon/TimeClockHourglass.png" alt="">
                            <span>  {{infos.postDetails.study_length}} دقیقه</span>

                            <transition name="fade">
                                    <span  v-if="dateMoreDetails" style="min-width: max-content;position: absolute;top: -30px;padding-right: 20px;left: 5px;background-color: white;height: 30px">خواندن این مطلب {{infos.postDetails.study_length}} دقیقه زمان می برد</span>
                            </transition>
                        </li>

                    </ul>
                </div>
                <div class="article-body">
                    <div v-for="content in infos.postContent" :key="content">

                        <div v-if="content.file_name">
                            <div class="video-container" v-if='content.file_type == "mp4" || content.file_type =="webm"'>
                                <PostVideoPlayer :content="content"/>
                            </div>
                            <div class="audio-container" v-else-if="content.file_type == 'mp3' || content.file_type =='ogg' || content.file_type =='wav'">
                                <PostAudioPlayer :content="content"/>
                            </div>
                            <div class="image-container" v-else-if="content.file_type =='gif' || content.file_type =='gif' || content.file_type =='jpg' || content.file_type =='jpeg' || content.file_type =='png'">
                                <img :src="$store.state.base_urls.postsUploads+content.file_name" alt="">
                                <div class="explain" v-if="content.file_title">
                                    {{content.file_title}}
                                </div>
                            </div>
                            <div class="file-container" v-else>
                                <div class="explain" v-if="content.file_title">
                                    {{content.file_title}}
                                </div>
                                <a :href="$store.state.base_urls.postsUploads+content.file_name" class="download-btn" download target="_blank">
                                    <span class="iconify" data-icon="akar-icons:download" data-inline="false"></span>
                                    <span style="margin: 0 10px 0 0">{{content.file_type}}</span>
                                </a>
                            </div>
                        </div>
                        <div v-else>
                            <div class="text-container"  v-html="content.text_content"></div>
                        </div>
                    </div>
                    <div id="footer-content">
                        <div class="row">
                            <div class="small-div col-lg-6 col-md-6 col-sm-12"  v-if="$store.state.socialMediaLinks.instagram">
                                <a :href="$store.state.socialMediaLinks.instagram"   target="_blank">
                                    <span>اینستاگرام کانادا از ایران</span>
                                    <img width="80" height="80" src="../assets/new/New/instagram.png" alt="">
                                </a>
                            </div>
                            <div class="small-div col-lg-6 col-md-6 col-sm-12"  v-if="$store.state.socialMediaLinks.telegram">
                                <a :href="$store.state.socialMediaLinks.telegram"   target="_blank">
                                    <span>کانال تلگرام کانادا از ایران</span>
                                    <img width="80" height="80" src="../assets/new/New/Logo.png" alt="">
                                </a>
                            </div>
                            <div class="small-div col-lg-6 col-md-6 col-sm-12">
                                <a v-on:click="$router.push('/user-signup')">
                                    <span>فرم ارزشیابی رایگان</span>
                                    <img width="80" height="80" src="../assets/new/New/Icon/clipboard.png" alt="">
                                </a>
                            </div>
                            <div class="small-div col-lg-6 col-md-6 col-sm-12">
                                <a v-on:click="$router.push('/faq')">
                                    <span>مشاهده سوالات متداول</span>
                                    <img width="80" height="80" src="../assets/new/New/Icon/qa.png" alt="">
                                </a>
                            </div>
                        </div>


                        <div id="footer-toolbar">
                            <div id="footer-body">
                                <div>
                                    <ul class="author-profile">
                                        <li class="author-pic">
                                            <img v-if="infos.adminDetails.file" width="45" height="45" :src="$store.state.base_urls.adminsUploads+infos.adminDetails.file" alt="">
                                            <img v-else width="45" height="45" src="../assets/defaults/man.jpg" alt="">
                                        </li>
                                        <li class="author-name"  v-if="infos.adminDetails" v-on:click="$router.push('/author-page/'+infos.adminDetails.username)">
                                            نویسنده:
                                            <span>
                                                {{infos.adminDetails.name}}
                                            </span>
                                        </li>
                                        <li class="author-name" v-else >
                                            نویسنده:
                                            <span>
                                                کارشناس سیستم
                                            </span>
                                        </li>
                                        <li class="publication-date">
                                            {{infos.postDetails.created_at}}
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <ul class="main-toolbar">
                                        <li class="saving-toolbar" v-on:click="handleSavingPost">
                                            <transition name="fade">
                                            <span v-if="bookmarkDetails && likeInput==false">
                                                <p v-if="infos.savedStatus">
                                                      حذف از نشان شده ها
                                                </p>
                                                <p v-else>
                                                      افزودن به نشان شده ها
                                                </p>
                                            </span>
                                            </transition>
                                            <img v-if="infos.savedStatus" @mouseover="showDetails('bookmarkDetails')" @mouseleave="hideDetails('bookmarkDetails')" width="15" height="20"  src="../assets/appIcons/Panel/Bookmarkkedsaved.png" alt="">
                                            <img v-else @mouseover="showDetails('bookmarkDetails')" @mouseleave="hideDetails('bookmarkDetails')" width="15" height="20"  src="../assets/new/New/Icon/Bookmarkk.png" alt="">
                                        </li>
                                        <li class="rate-toolbar"  v-on:click="handleLikingPost">
                                            <span>
                                                 {{infos.likesCount}}
                                            </span>
                                            <img v-if="infos.currentUserLike" width="20" height="20"  src="../assets/new/New/Icon/LikeGreen.png" alt="">
                                            <img v-else width="20" height="20"  src="../assets/new/New/Icon/Like.png" alt="">
                                        </li>
                                        <li class="like-toolbar">
                                            <transition name="fade">
                                            <div class="like-input" v-if="likeInput">
                                                <div class="like-input-txt">
                                                    امتیاز شما به این مقاله:
                                                </div>
                                                <div class="like-input-star">
                                                    <img width="20" height="20" class="star-pic" v-on:click="handleRatingPost(1)" v-on:mouseover="changeScoreNum(1)" v-on:mouseleave="resetScoreNum()"  :src="score>0 ? require('../assets/new/New/Icon/StarOutline.png') : require('../assets/new/New/Icon/StarOutlineCopy.png')" alt="">
                                                    <img width="20" height="20" class="star-pic" v-on:click="handleRatingPost(2)" v-on:mouseover="changeScoreNum(2)" v-on:mouseleave="resetScoreNum()"  :src="score>1 ? require('../assets/new/New/Icon/StarOutline.png') : require('../assets/new/New/Icon/StarOutlineCopy.png')" alt="">
                                                    <img width="20" height="20" class="star-pic" v-on:click="handleRatingPost(3)" v-on:mouseover="changeScoreNum(3)" v-on:mouseleave="resetScoreNum()"  :src="score>2 ? require('../assets/new/New/Icon/StarOutline.png') : require('../assets/new/New/Icon/StarOutlineCopy.png')" alt="">
                                                    <img width="20" height="20" class="star-pic" v-on:click="handleRatingPost(4)" v-on:mouseover="changeScoreNum(4)" v-on:mouseleave="resetScoreNum()"  :src="score>3 ? require('../assets/new/New/Icon/StarOutline.png') : require('../assets/new/New/Icon/StarOutlineCopy.png')" alt="">
                                                    <img width="20" height="20" class="star-pic" v-on:click="handleRatingPost(5)" v-on:mouseover="changeScoreNum(5)" v-on:mouseleave="resetScoreNum()"  :src="score>4 ? require('../assets/new/New/Icon/StarOutline.png') : require('../assets/new/New/Icon/StarOutlineCopy.png')" alt="">
                                                </div>
                                            </div>
                                            </transition>
                                            <span>
                                                 ({{infos.scoresCount}}) {{infos.ratingsResult}}
                                            </span>
                                            <img class="like-input-star-main-star"  @click="showHideToggle('likeInput')" width="18" height="18"  src="../assets/new/New/Icon/StarOutline.png" alt="">
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div id="footer-footer">
                                <div class="footer-footer-text-content">اشتراک گذاری در:</div>
                                <div class="footer-footer-icon-content">
                                    <ul>
                                        <!--
                                        <li>
                                            <img class="colorful" width="24" height="24" src="../assets/new/New/Icon/SocialMedia/Aparat.png" alt="">
                                            <img class="non-colored"  width="24" height="24" src="../assets/new/New/Icon/NonColoredSocialMedia/Aparat.png" alt="icon">
                                        </li>
                                        -->
                                        <li>
                                            <a :href="'https://telegram.me/share/url?url='+currentLocation"  target="_blank">
                                            <img class="colorful" width="24" height="24" src="../assets/new/New/Icon/SocialMedia/Telegram.png" alt="icon">
                                            <img class="non-colored"  width="24" height="24" src="../assets/new/New/Icon/NonColoredSocialMedia/Telegram.png" alt="icon">
                                            </a>
                                        </li>
                                        <li>
                                            <a  :href="'http://twitter.com/share?text=canada-az-iran&url='+ currentLocation" target="_blank">
                                            <img class="colorful" width="24" height="24" src="../assets/new/New/Icon/SocialMedia/Twitter.png" alt="">
                                            <img class="non-colored"  width="24" height="24" src="../assets/new/New/Icon/NonColoredSocialMedia/Twitter.png" alt="icon">
                                            </a>
                                        </li>
                                        <li>
                                            <a :href="'whatsapp://send?text='+currentLocation" data-action="share/whatsapp/share"  target="_blank">
                                            <img class="colorful" width="24" height="24" src="../assets/new/New/Icon/SocialMedia/Youtube.png" alt="">
                                            <img class="non-colored"  width="24" height="24" src="../assets/new/New/Icon/NonColoredSocialMedia/Youtube.png" alt="icon">
                                            </a>
                                        </li>
                                        <li>
                                            <a :href="'https://www.linkedin.com/shareArticle?mini=true&url='+currentLocation+'&title=canada-az-iran'"  target="_blank">
                                                <img class="colorful" width="24" height="24" src="../assets/new/New/Icon/SocialMedia/LinkedIn.png" alt="">
                                                <img class="non-colored"  width="24" height="24" src="../assets/new/New/Icon/NonColoredSocialMedia/LinkedIn.png" alt="icon">

                                            </a>
                                        </li>
                                        <!--
                                        <li>
                                            <img class="colorful" width="24" height="24" src="../assets/new/New/Icon/SocialMedia/Instagram.png" alt="">
                                            <img class="non-colored"  width="24" height="24" src="../assets/new/New/Icon/NonColoredSocialMedia/Instagram.png" alt="icon">
                                        </li>
                                        -->
                                        <li>
                                            <a  :href="'https://www.facebook.com/sharer/sharer.php?u='+ currentLocation" target="_blank">
                                                <img class="colorful" width="24" height="24" src="../assets/new/New/Icon/SocialMedia/Facebook.png" alt="icon">
                                                <img class="non-colored"  width="24" height="24" src="../assets/new/New/Icon/NonColoredSocialMedia/Facebook.png" alt="icon">
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div  :class="infos.related_posts ? 'col-lg-9 col-md-8 col-sm-12 article-content' : 'col-sm-12 article-content'" v-else>
                <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
            </div>

            <div class="col-lg-3 col-md-4 col-sm-12 article-content" v-if="infos.related_posts">
                <div id="suggested-content">
                    <div id="suggested-content-header">
                        مطالب پیشنهادی
                    </div>
                    <ul>
                        <li v-for="relatedPost in infos.related_posts" :key="relatedPost"   v-on:click="$router.push('/article-view/'+relatedPost.slug)">
                            <a :href="'/article-view/'+relatedPost.slug" onclick="return false">
                                <div class="suggested-content-title">
                                <span class="title-details">
                                    {{relatedPost.title}}
                                </span>
                                    <span class="date-details">
                                  {{relatedPost.created_at}}
                                </span>
                                </div>
                                <div class="suggested-content-summary">
                                    {{relatedPost.summary}}
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div  v-if="loadingMood && !infos">
            <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>

        <div id="category-content">
            <div class="space"></div>
            <div class="main-container category-content container-size-fixer">
                <SubCategory/>
            </div>
            <!--<div class="space"></div>-->
            <!--<div class="main-container category-content container-size-fixer">-->
                <!--<Category :SubCategory="true"/>-->
            <!--</div>-->
            <!--<div class="space"></div>-->
        </div>


        <div class="main-box-content" v-if="loginStatus == 'true' && infos && infos.postDetails.comment_permission">
            <div class="title form-title" style="margin-top: 0">
                <ul>
                    <li>
                        <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                        افزودن نظر
                    </li>
                </ul>
            </div>
            <div class="form-container">
                <CommentForm :type="'post'" :slug="slug" parentId=""/>
            </div>
        </div>
        <div class="notice-box" v-else-if="infos &&  infos.postDetails.comment_permission">
            <div class="main-box-content">
                <div class="row form-container login-txt" v-on:click="$router.push('/user-signin')" >
                    برای افزودن نظر جدید وارد شوید!
                </div>
            </div>
        </div>

        <div class="space"></div>
        <div class="main-box-content" v-if="comments">
            <div class="title form-title">
                <ul>
                    <li>
                        <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                       نظرات کاربران
                    </li>
                </ul>
            </div>
            <div v-for="comment in comments" :key="comment">
                <UserComment :layersCount="1" :comment="comment" :type="'post'" :replyTo="null" :slug="slug"/>
            </div>
        </div>
        <div  v-if="commentsLoadingMood">
            <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>

    </div>
</template>

<script>
    import Alert from '../components/Alert'
    import UserComment from '../components/UserComment'
    import SubCategory from '../components/SubCategory'
    import PostVideoPlayer from  '../components/PostVideoPlayer'
    import PostAudioPlayer from  '../components/PostAudioPlayer'
    import CommentForm from  '../components/CommentForm'
    import axios from 'axios'
    export default {
        name: "ArticleView",
        data() {
            return {
                alertContent: null,
                loadingMood: false,
                commentsLoadingMood: false,
                dateMoreDetails: false,
                likeInput: false,
                bookmarkDetails:false,
                windowWidth: window.innerWidth,
                slug:this.$route.params.slug,
                infos:null,
                loginStatus: localStorage.getItem('loginStatus'),
                score:0,
                comments:null,
                currentLocation:document.URL,
            }
        },
        components:{
            UserComment,
            Alert,
            SubCategory,
            PostVideoPlayer,
            PostAudioPlayer,
            CommentForm
        },
        methods: {
           changeScoreNum(num){
               this.score = num;
           },
           resetScoreNum(){
               if(this.infos){
                   if(this.infos.currentUserScore){
                       this.score = this.infos.currentUserScore;
                   }else{
                       this.score = 0;
                   }
               }
           },
           async handleLikingPost(){
                    try {
                        //this.loadingMood = true;
                        let response = await axios.post('api/postChangingLikingStatus/' + this.slug);
                        //this.loadingMood = false;
                        this.infos.currentUserLike = response.data.currentUserLike;
                        this.infos.likesCount = response.data.likesCount;
                    } catch (error) {
                        console.log(error)
                    }
            },
           async handleRatingPost(score){
                    try {
                        this.score = score;
                        //this.loadingMood = true;
                        const formData = new FormData();
                        formData.append('slug', this.slug);
                        formData.append('score', score);
                        let response = await axios.post('api/postChangingScore',formData);
                        //this.loadingMood = false;
                        this.infos.currentUserScore= response.data.currentUserScore;
                        this.infos.scoresCount= response.data.scoresCount;
                        this.infos.ratingsResult= response.data.ratingsResult;
                        this.resetScoreNum();
                    } catch (error) {
                        console.log(error)
                    }
            },
           async handleSavingPost(){
                if(this.loginStatus == 'true'){
                        try {
                            //this.loadingMood = true;
                            let response = await axios.post('/api/userDashboard/postChangingSavingStatus/' + this.slug,
                                {
                                    headers:
                                        {
                                            "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                        }
                                });
                            //this.loadingMood = false;
                            this.infos.savedStatus = response.data.savedStatus;
                        } catch (error) {
                            console.log(error)
                        }
                }else{
                    this.alertContent =
                    {
                        message: 'برای ذخیره مطالب ابتدا وارد حساب کاربری خود شوید.',
                        imageUrl:require('../assets/new/New/Block.png'),
                        buttonType:'close',//close
                        buttonText:'ورود به حساب کاربری',
                        buttonLink:'/user-signin',
                        waitingMode:false,
                        closeButtonShow:true
                    }
                }
            },
            showHideToggle(type){
                if (type == 'likeInput') {
                    if(this.likeInput){
                        this.likeInput = false
                    }else{
                        this.likeInput = true
                    }
                }
            },
            showDetails(type) {
                if (type == 'dateMoreDetails') {
                    this.dateMoreDetails = true
                }
                if (type == 'bookmarkDetails') {
                    this.bookmarkDetails = true
                }
                console.log(this.dateMoreDetails)
            },
            hideDetails(type) {
                if (type == 'dateMoreDetails') {
                    this.dateMoreDetails = false
                }
                if (type == 'bookmarkDetails') {
                    this.bookmarkDetails = false
                }
                console.log(this.dateMoreDetails)
            },
            onResize() {
                this.windowWidth = window.innerWidth
            },

            async getPostInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getPostInfos/' + this.slug,
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                    this.loadingMood = false;
                    this.infos = response.data.results;
                    this.resetScoreNum();
                } catch (error) {
                    console.log(error)
                }
            },

            async getComments() {
                try {
                    this.commentsLoadingMood = true;
                    let response = await axios.get('api/getPostComments/' + this.slug,
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                    this.commentsLoadingMood = false;
                    this.comments = response.data.results;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPostInfos();
            this.getComments();
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        watch: {
            $route(to, from) {
                this.loginStatus = localStorage.getItem('loginStatus');
                if (to !== from) {
                    this.slug = this.$route.params.slug;
                    this.getPostInfos();
                    this.getComments();
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .login-txt{
        cursor: pointer;
        &:hover{
            text-decoration: underline;
        }
    }
    .notice-box{
        background-color: rgba(232, 232, 232, 0.5);
        width: 100%;
        color: black;
    }
    .saving-toolbar{
        img{
            cursor:pointer;
        }
        position: relative;
        span{
            position: absolute;z-index: 5;top: 0px;left: 30px;width: max-content
        }
    }
    .author-pic{
        img{
            border-radius: 50%;
        }
    }
    .video-container{
        margin: 50px 0;
        .explain{
            margin-top: 10px;
        }
    }
    .audio-container{
        margin: 50px 0;
        .explain{
            margin-top: 10px;
        }
    }
    .file-container{
        margin: 50px 0;
        border: 2px solid lightgray;
        padding: 15px;
        border-radius: 10px;
    }
    .image-container{
        margin: 50px 0;
        img{
            width: 100%;
            height: auto;
        }
        .explain{
            margin-top: 10px;
        }
    }
    .file-container{
        margin: 50px 0;
        width: 100%;
        height: auto;
        text-align: right;
        font-size: 20px;
        min-height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 2px solid lightgrey;
        a{
            width: 100px;
            height: auto;
            text-align: left;
        }
        .explain{
            width:calc(100% - 90px);
            font-size: 17px;
        }
    }
    #article-view {
    background-color: white;
    .SubCategory-content{
        overflow-x: hidden;
        margin: auto;
    }
    #question-form{
        max-width: 1120px;
        width: 100%;
        background-color: black!important;
        margin: auto;
        padding: 50px 15px;
    }
    .space{
        height: 10px;
        width: 100%;
        background-color: #162336;
    }
    #direction>ul{
        padding: 0;
        text-align: right;
        list-style-type: none;
    }
    #direction>ul>li{
        min-width: 30px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }
    #direction>ul>li:nth-child(3){
        opacity: 0.3;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }
    .main-box-content{
        max-width: 1120px;
        width: 100%;
        margin: auto;
        padding: 50px 0;
        .title{
            width: 100%;
            text-align: right;
            font-size: 30px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1a1a1a;
            span{
                color: #cc171d;
            }
        }
    }
    .title{
        margin-top: 30px;
        width: 100%;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        ul{
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;

            li{

                padding: 5px;
                img{
                    margin-top: 5px;
                    width: 9px!important;
                    height: auto!important;
                }
                display: inline-block;
                span{
                    color: #cc171d;
                }
            }
        }

    }
    .form-title{
        ul{
            padding: 0;
        }
        font-size: 22px!important;
    }
    .form-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #detail-txt>a{
        color: #162336;
        text-decoration: underline;
    }
    button{
        max-width: 369px;
        width: 90%;
        height: 54px;
        margin: auto;
        background-color: #162336;
        color: white;
        border: solid 1px #979797;
        border-radius: 10px;
        transition: 0.1s all;
    }
    button:hover{
        background-color: #fe7063;
        color: white;
    }



    label {
        position: absolute;
        pointer-events: none;
        right: 10px;
        top: 5px;
        transition: 0.2s;
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        opacity: 1;
    }


    #register-form-content>form{
        margin-top: 50px;
    }

    .suggested-content-summary{
        width: 100%;
        height: 50px;
        font-size: 12px;
        display:inline-block;
        padding-top: 10px;
        text-align: right;
    }
    .suggested-content-title{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-details{
            text-align: right;
            width: 100%;
            color: #262626;
            font-size: 14px;
            font-weight: bold;
            overflow:hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .date-details{
            float: left;
            font-size: 14px;
            font-weight: normal;
            color: rgba(22,22,22,0.5);
        }
    }
    #suggested-content-header{
        width: 100%;
        background-color: #262626;
        padding-right: 15px;
        text-align: right;
        line-height: 44px;
        height: 44px;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        color: white;
    }
    #suggested-content{
        border-radius: 10px;
        background-color: rgba(232, 232, 232, 0.5);
        ul{
            padding:15px 0;
            list-style-type: none;
            li{
                cursor: pointer;
                padding: 0 11px;
                display: block;
                width: 100%;
                min-height: 65px;
                height: auto;
            }
        }
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 0;
        min-width: 220px;
        width: 100%;
        margin: auto;
        height: auto;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    .article-content:nth-child(2){
        padding: 0 15px 0 15px;
    }
    @media (max-width: 768px) {

        .article-content:nth-child(2){
            padding: 0px;
        }

    }
    .footer-footer-icon-content{
        width: 100%;
        text-align: left;
        padding: 20px 0 0 20px;
        ul{
            float: left;
            max-width: 300px;
            width: 100%;
            height: auto;
            list-style-type: none;
            display:table;
            padding: 0;
            box-sizing:border-box;
            -moz-box-sizing:border-box;
            -webkit-box-sizing:border-box;

            li{
                cursor: pointer;
                .colorful{
                    display: none;
                }
                &:hover{
                    .colorful{
                        display: inline;
                    }
                    .non-colored{
                        display: none;
                    }
                }
                width: auto;
                height: auto;
                display:table-cell;
            }
        }
    }
    .footer-footer-text-content{
        padding-right: 20px;
        width: 30%;
        text-align: right;
        font-size: 16px;
    }
    .like-input-star-main-star{
        cursor: pointer;
    }
    .star-pic{
        margin: 0 2px;
    }
    .like-input-star{
        direction: ltr!important;
        text-align: left;
        padding-left: 10px;
    }
    .like-input-txt{
        font-size: 16px!important;
        padding-right: 10px;
        text-align: right;
    }
    .like-toolbar{}
    .like-input{
        z-index: 10;
        div{
            display: inline-block;
            height: 100%;
        }
        top: -40px;
        max-width: 390px!important;
        width: 100%;
        left: 0;
        height: 40px;
        line-height: 40px;
        position: absolute;
        background-color: rgba(232,232,232,0.5);
        border-radius: 10px;
    }
    .like-toolbar ,  .rate-toolbar{
        span{
            padding: 0 15px 0 0;
        }
        img{
            cursor: pointer;
            margin-right: 5px;
        }
    }
    #footer-body{
        div{
            display: inline-block;
            width: 50%;
            .author-profile{
                text-align: right;
                margin: 0;
                padding: 0;
                list-style-type: none;
                li{
                    width: auto;
                    height: auto;
                    display: inline-block;
                };
                .author-name{
                    cursor: pointer;
                    padding: 0 10px;
                    border-left: 2px solid #bbc5d6;
                    &:hover{
                        text-decoration: underline;
                    }
                }
                .publication-date{
                    padding: 0 10px;
                }


            }

            .main-toolbar{
                /*position: relative;*/
                text-align: left;
                margin: 0;
                padding: 0;
                list-style-type: none;
                li{
                    width: auto;
                    height: auto;
                    display: inline-block;
                };
            }
        }
    }
    @media(max-width: 670px){
        #footer-body{
            div{
                width: auto;
            }
    }
    }
    #footer-body,#footer-footer{
        width: 100%;
    }
    #footer-footer{
        margin-top: 20px;
        div{
            display: inline-block;
            height: 100%;
        }
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(232,232,232,0.5);
        border-radius: 10px;
        min-height: 50px;
        height: auto;
    }
    #footer-body{
        padding-bottom: 20px;
        min-height: 40px;
        height: auto;
        border-bottom: 2px solid rgba(178,178,178,0.5);
        position: relative;
    }
    #footer-toolbar{
        min-height: 100px;
        width: 100%;
        margin-top: 100px;
    }
    #footer-content{
        width: 100%;
        height: auto;
        margin-top: 75px;
        overflow: hidden;

    }
    .small-div{
        min-height: 140px;
        a{
            cursor: pointer;
            padding: 10px;
            margin-top: 15px;
            width: 100%;
            height: 140px;
            background-color: #162336;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            span{
                font-size: 16px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                margin: 20px;
            }
            image{

            }
        }
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.1s ease;
    }
    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
    .article-footer {
        width: 100%;
    }
    .article-header-details {
        padding: 0;
        list-style-type: none;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        li {
            cursor: pointer;
            width: max-content;
            padding-right: 10px;
            padding-left: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px !important;
            img {
                margin-left: 15px;
                /*display: inline-block;*/
                /*min-width: 45px;*/
                /*width: auto;*/
                /*cursor: pointer;*/
                /*min-height: 50px;*/
            }
        }
    }
    .arrow {
        position: static !important;
    }
    .title {
        margin-top: 30px;
        width: 100%;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        ul {
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;

            li {
                padding: 5px;

                img {
                    margin-top: 5px;
                    width: 9px !important;
                    height: auto !important;
                }

                display: inline-block;

                span {
                    color: #cc171d;
                }
            }
        }

    }
    #direction > ul {
        text-align: right;
        list-style-type: none;
      padding: 0;
    }
    #direction > ul > li {
        min-width: 30px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }
    #direction > ul > li:nth-child(3), #direction > ul > li:nth-child(1) {
        opacity: 0.3;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }
    /******/
    .article-header, .article-body {
        width: 100%;
        height: auto;
    }
    .article-header{
       min-height: 170px;
    }
    .article-body{
        overflow: hidden;
        margin-top: 0;
    }
    .article-header {
        overflow-x: hidden;
    }
    #main-content {
        padding-top: 30px;
        padding-bottom: 30px;
    }
    #main-content {
        .article-content {
            &:nth-child(1){
                /*overflow-x: hidden;*/
            }
            margin-top: 20px;
            padding: 0 15px;
        }

        margin: auto;
    }
    .details{

    }
    @media (max-width: 1300px) {
        .footer-footer-text-content{
            display: none!important;
        }
    }
    }
    @media (max-width: 1150px) {
        .main-box-content{
            padding: 50px 15px !important;
        }
    }
</style>